import { defineComponent } from 'vue'
import { faPlay, faPlus, faCheck, faRedo } from '@fortawesome/free-solid-svg-icons'

import { TaskLifecycleStates } from '@skinsoft/types'
import { taskSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'

import {
    CREATE_COMPLEX_MOVEMENT_FROM_TASK_TOPIC,
    CREATE_SIMPLE_MOVEMENT_FROM_TASK_TOPIC,
    REJECT_TASK_TOPIC,
    START_TASK_TOPIC,
    TERMINATE_TASK_TOPIC,
} from '../../../../busTopics'

export const ActionMenuTask = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['entityDataStore'],
    template: require('./action-menu-task.html'),
    data() {
        return {
            plusIcon: faPlus,
            playIcon: faPlay,
            backIcon: faRedo,
            checkIcon: faCheck,
            entity: null as any,

            canCreate: false,
            canStartTask: false,
            canRejectTask: false,
            canTerminateTask: false,
        }
    },
    computed: {
        noPossibleActions(): boolean {
            return !this.canCreate && !this.canStartTask && !this.canTerminateTask && !this.canTerminateTask
        },
    },
    created() {
        this.subscribeToEntity()
    },
    methods: {
        createComplexMovement() {
            this.emitOnBus(CREATE_COMPLEX_MOVEMENT_FROM_TASK_TOPIC)
            this.$emit('toggle')
        },

        createSimpleMovement() {
            this.emitOnBus(CREATE_SIMPLE_MOVEMENT_FROM_TASK_TOPIC)
            this.$emit('toggle')
        },

        rejectTask() {
            this.emitOnBus(REJECT_TASK_TOPIC)
            this.$emit('toggle')
        },

        startTask() {
            this.emitOnBus(START_TASK_TOPIC)
            this.$emit('toggle')
        },

        terminateTask() {
            this.emitOnBus(TERMINATE_TASK_TOPIC)
            this.$emit('toggle')
        },

        subscribeToEntity() {
            this.subscribeTo(
                this.entityDataStore.fetchOne(this.$route.params.id),
                (entity) => {
                    this.entity = entity
                },
                'entity',
            )
        },

        onDataStoreChange() {
            this.unsubscribeFrom('entity')
            this.subscribeToEntity()
        },

        onEntityChange(entity) {
            const linkableItems = taskSelectors.linkableItems(entity)
            this.canCreate = linkableItems.length > 0 && taskSelectors.state(entity) !== TaskLifecycleStates.FINALIZED

            // SHOULD BE LINK TO REAL DATA ONCE API IS READY
            this.canRejectTask = taskSelectors.state(entity) === TaskLifecycleStates.IN_PROGRESS
            this.canStartTask = taskSelectors.state(entity) === TaskLifecycleStates.PLANNED
            this.canTerminateTask = taskSelectors.state(entity) === TaskLifecycleStates.IN_PROGRESS
        },
    },
    watch: {
        '$route': {
            handler: 'onDataStoreChange',
            deep: true,
        },
        entityDataStore: {
            handler: 'onDataStoreChange',
        },
        entity: {
            handler: 'onEntityChange',
            deep: true,
            immediate: true,
        },
    },
})
